import { AxiosResponse } from "axios";
import { ErrorInfo } from "react";
import { ApiResponse } from "../Data/apiResponse";
import { LookupInterface } from "../Pages/CompanyAccount/model/accountForm.model";
import { axiosService } from "../Services/common/Axios.service";
import { LookupPayload, LookupType } from "../Services/common/lookup.service";
interface LookupItem {
  [key: string]: any;
}
interface AdvanceFilterPayload {
  [key: string]: any;
}

export const stringSeparator = (
  sentence: string,
  replaceFrom: string,
  replaceTo: string
): string => {
  const x = sentence.replace(replaceFrom, replaceTo);
  return x;
};

export const captializeString = (name: string) => {
  return name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const generateRandom10DigitNumber = (
  min: number,
  max: number
): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Type Assertion Utility
export function getEnvVar(key: any, fallback?: string): string {
  const value = key;
  if (!value) {
    throw new Error(`Environment variable ${key} is not defined.`);
  }
  return value;
}
//
/**
 * It takes a File object as input and returns a Promise that resolves
 * with the base64 representation of the file.
 * @param {File} file - File object that represents the file to be converted to Base64.
 * @returns Rreturns a Promise that resolves with a base64 string
 * representation of the provided File object.
 */
export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // Read file as Data URL (Base64)
    reader.onload = () => {
      // only return the base64 string
      let base64String = (reader.result as string).split(",").pop();
      resolve(base64String || "");
    };
    reader.onerror = (error) => reject(error);
  });
};

export const transform = (
  response: AxiosResponse
): Promise<ApiResponse<any>> => {
  return new Promise((resolve, reject) => {
    const result: ApiResponse<any> = {
      data: response.data.data,
      metaData: response.data.meta,
      succeeded: response.status === 200,
      errors: response.data.errors,
    };
    resolve(result);
  });
};
export function formatNumber(num: any) {
  if (!num) return num;
  return Math.round(num);
}
//
export const formatDate = (dateString: string) => {
  // Create a Date object from the input string
  const date = new Date(dateString);

  // Extract the day, month, and year
  const day = String(date.getUTCDate()).padStart(2, "0"); // Get the day and pad with leading zero
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Get the month (0-indexed) and pad
  const year = date.getUTCFullYear(); // Get the full year

  // Format the date as MM/DD/YYYY
  return `${month}/${day}/${year}`;
};

// Create function that will help in transforming API data based on the type Of model we provide.

export const transformData = <T extends object>(
  models: T[],
  apiData: Record<string, any>
): Record<string, T> => {
  const result: Record<string, T> = {};

  for (const model of models) {
    const modelInstance = Object.assign(
      Object.create(Object.getPrototypeOf(model)),
      model
    );

    const modelKeys = Object.keys(model);
    
    for (const key of modelKeys) {
      if (key in apiData) {
        const expectedType = typeof (model as any)[key];
        const value = apiData[key];

        // Handle null and undefined values
        if (value === null || value === undefined) {
          (modelInstance as any)[key] = null;
          continue;
        }

        // Handle type conversion while preventing null stringification
        switch (expectedType) {
          case "string":
            (modelInstance as any)[key] = typeof value === "string" ? value : String(value);
            break;
          case "number":
            (modelInstance as any)[key] = value === "" ? null : Number(value);
            break;
          case "boolean":
            (modelInstance as any)[key] = value === "true" || value === true || value === 1;
            break;
          default:
            (modelInstance as any)[key] = value;
        }
      }
    }

    const modelName = model.constructor.name;
    result[modelName] = modelInstance;
  }

  return result;
};


export const getLookup = (SERVICE_URL: string, lookupType: LookupType) => {
  const payload: LookupPayload = {
    params: {
      types: [lookupType]
    },
  };
  return axiosService.get(`${SERVICE_URL}global/lookup/uom_system`, payload);
};

export const getFileExtension = (filename: string) => {
  if (filename) {
    return filename?.split(".")[1];
  }
};

export const getLocalStorageItem = (itemName: string): string | false => {
  if (itemName) {
    const itemData = localStorage.getItem(itemName);
    return itemData !== null ? itemData : false;
  }
  return false;
};


export const errorHandler = (error: Error, info: ErrorInfo) => {
  console.log("Error Descriiption: ", error, "Error Info: ", info)

};
export const prepareSearchColumns = (db_columns: { data: string }[], exclude_columns: string[]) => {
  return db_columns
    .filter((column) => !exclude_columns.includes(column.data))
    .map((column) => {
      let text = column.data.replace(/\bas\s+\w+/g, "").trim(); 
      return text;
    });
};
export const formatPhoneNumber = (input: any) => {
  if(!input) return input;
  // Remove all non-digit characters
  const cleaned = input.replace(/\D/g, "");

  // Apply the US phone number format (xxx-xxx-xxxx)
  let formatted = "";
  if (cleaned.length > 0) {
    formatted += cleaned.substring(0, 3);
  }
  if (cleaned.length > 3) {
    formatted += "-" + cleaned.substring(3, 6);
  }
  if (cleaned.length > 6) {
    formatted += "-" + cleaned.substring(6, 10);
  }

  return formatted;
};
export function isNumber(value:any) {
  return !isNaN(value) && !isNaN(parseFloat(value));
}
export function formatString(inputString:any) {
  if (typeof inputString !== 'string' || inputString.length === 0) {
    return "";
  }

  const words = inputString.split('-');

  const capitalizedWords = words.map(word => {
    if (word.length === 0) return ""; 

    return word.charAt(0).toUpperCase() + word.slice(1); 
  });

  return capitalizedWords.join(' ');
}

// Finding the data from arary of object by passing data in which it will find and the paramter with which i will be matching

export function  findDataObjectByParameter(dataList: any, attribute: string, paramterToSearch: string){
  try{
    const data= dataList.find((obj: any)=> obj[attribute] === paramterToSearch);
    return data;
  }
  catch(error){
    console.log("Something went wrong")
  }
}


// Transform Data into 
export const transformLookupToSelectOptions = (
  data: LookupItem[] | undefined,
  fields: { labelField: string; valueField: string } = { labelField: 'description', valueField: 'code' }
): LookupInterface[] => {
  if (!data) return [];
  
  return data.map((item) => ({
    label: item[fields.labelField],
    value: item[fields.valueField],
  }));
};


export const formSelectOptionList = (data: any) => {
  return data?.map((item: any) => ({
    value: item.code,
    label: item.name,
  }));
}

export const formatInputData = (value: any) => {
  if (value && typeof value === 'object' && 'code' in value) {
    return value;
  }
  return { code: value };
};
export const getProfileName = (fullName: string): string => {
  if (!fullName || typeof fullName !== 'string') return '';

  const names = fullName.trim().split(/\s+/);
  const firstName = names[0];
  const lastName = names.length > 1 ? names[names.length - 1] : '';

  if (lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase(); // e.g., JS
  } else {
    return firstName.slice(0, 2).toUpperCase(); // e.g., Jo
  }
};


export const buildFilterConditions = (filters: AdvanceFilterPayload,AdvanceFilterMapper:any): any[][] => {
  const filters_conditions: any[][] = [];

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== "") {
      filters_conditions.push([AdvanceFilterMapper[key], "=", value]);
    }
  });
  
  return filters_conditions;
};

export const toUpperCase = (value: string): string => {
  return value?.toUpperCase?.() || '';
};

export const isValidDate = (str: string): boolean => {
  const spaceFormattedDate = str ? str.replace(/\s+/g, "") : "";
  const datePattern = /^(0?[1-9]|1[0-2])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-](\d{4})$/;
  return datePattern.test(spaceFormattedDate);
};

export const formatSearchDate = (search: string) => {
  const spaceFormattedDate = search ? search.replace(/\s+/g, "") : "";
  const datePattern = /^(0?[1-9]|1[0-2])[/\-](0?[1-9]|[12][0-9]|3[01])[/\-](\d{4})$/;
  const match = spaceFormattedDate.match(datePattern);
  if (match) {
    const [_, mm, dd, yyyy] = match;
    return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
  }
  return spaceFormattedDate;
};